import JobsList from "@/pages/JobsList";

/** True Home — landing page: all-jobs pin map + every month's job tiles (same tiles, status boxes and actions as the Jobs list). */
export default function Home() {
  return <JobsList mode="home" />;
}
